import React from 'react';

export function PillStatus(props) {
  let text = "";
  let color = "light"
  switch(props.children) {
    case 'N':
      text = 'ร่าง/ใหม่';
      color = 'secondary';
      break;

    case 'W':
      text = 'รออนุมัติ';
      color = 'warning';
      break;

    case 'A':
      text = 'อนุมัติ';
      color = 'primary';
      break;
        
    case 'Y':
      text = 'ระหว่างผลิต';
      color = 'info';
      break;

    case 'Z':
      text = 'ผลิตเสร็จ';
      color = 'success';
      break;
  
    case 'X':
      text = 'ยกเลิก';
      color = 'light';
      break;
  
    default:
      text = props.children;
      color = 'light';
      break;
  }

  return <span className={`badge badge-pill badge-${color}`}>{text}</span>
}
